import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const ProfessionalSpecialtiesShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Professional ID" source="professional_id" />
      <TextField label="Specialty Name" source="specialty.name" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ProfessionalSpecialtiesShow.query = gql`
  query GET_ONE($id: Int!) {
    professionalSpecialty(id: $id) {
      id
      specialty_id
      professional_id
      specialty {
        id
        name
        label
      }
      created_at
      updated_at
    }
  }
`;

export default ProfessionalSpecialtiesShow;
